import styled from 'styled-components';

export const AnimatedWords = styled.span`
  .text-animate-hover {
    min-width: 10px;
    display: inline-block;
    animation-fill-mode: both;
  }
`;
